import '../components/web/compnents/App.css';
import 'aos/dist/aos.css';

import React, { Suspense, lazy } from 'react';
import { HashRouter, Routes, Route } from "react-router-dom";

// Web Components
import Home from '../components/web/compnents/pages/Home';
import Frontend from './web/compnents/Frontend';
import MyAccount from './web/compnents/Header/MyAccount';
import Success from './web/compnents/common/staps/Success';
import BookingDetails from './web/compnents/Header/BookingDetails';
import MyBookings from './web/compnents/Header/MyBookings';

// Lazy Loaded Public Pages
const About = lazy(() => import('../components/web/compnents/pages/About'));
const Gallery = lazy(() => import('../components/web/compnents/pages/Gallery'));
const ContactUs = lazy(() => import('../components/web/compnents/pages/ContactUs'));
const Blog = lazy(() => import('../components/web/compnents/pages/Blog'));
const Services = lazy(() => import('../components/web/compnents/pages/Services'));
const SubServices = lazy(() => import('../components/web/compnents/pages/SubServices'));
const SingleBlog = lazy(() => import('../components/web/compnents/pages/SingleBlog'));

// Lazy Loaded Admin
const Login = lazy(() =>
    import('../components/admin/components/Login/Login')
);

const AdminRoutes = lazy(() =>
    import('./admin/components/AdminRoutes')
);

function App() {

    const auth = localStorage.getItem("adminEmail");
    const auth1 = localStorage.getItem('auth1');
    const adminAccess = localStorage.getItem("adminType");

    return (
        <HashRouter>
            <Suspense fallback={<div>Loading...</div>}>

                <Routes>

                    {/* Frontend Routes */}
                    <Route path="/" element={<Frontend />}>

                        <Route index element={<Home />} />

                        <Route path="about" element={<About />} />
                        <Route path="gallery" element={<Gallery />} />
                        <Route path="contactus" element={<ContactUs />} />
                        <Route path="blog" element={<Blog />} />

                        <Route
                            path="blog/:id/:name"
                            element={<SingleBlog />}
                        />

                        <Route
                            path="services/:id/:name"
                            element={<Services />}
                        />

                        <Route
                            path="services/:subname/:sid/:id"
                            element={<SubServices />}
                        />

                        <Route
                            path="profile"
                            element={
                                localStorage.length > 0 && auth1
                                    ? <MyAccount />
                                    : <Home />
                            }
                        />

                        <Route
                            path="my-bookings"
                            element={
                                localStorage.length > 0 && auth1
                                    ? <MyBookings />
                                    : <Home />
                            }
                        />

                        <Route
                            path="booking/:id"
                            element={
                                localStorage.length > 0 && auth1
                                    ? <BookingDetails />
                                    : <Home />
                            }
                        />

                        <Route
                            path="success/:id"
                            element={<Success />}
                        />

                    </Route>

                    {/* Admin Routes */}
                    {auth ? (
                        <Route
                            path="/admin/*"
                            element={
                                <AdminRoutes
                                    adminAccess={adminAccess}
                                />
                            }
                        />
                    ) : (
                        <Route
                            path="/admin"
                            element={<Login />}
                        />
                    )}

                </Routes>

            </Suspense>
        </HashRouter>
    );
}

export default App;